import { render } from "./GroupsComponent.vue?vue&type=template&id=17da9401"
import script from "./GroupsComponent.vue?vue&type=script&lang=js"
export * from "./GroupsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__